module.exports = __webpack_public_path__ + "img/PBowman64_ua.7ed0259b.webp";